var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService } from '../../../../../services/modules/brand-client.service';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import * as Enumerable from 'linq';
import { NotificationClientService, NotificationType } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
var ManageLotteriesOperatorDialog = /** @class */ (function () {
    function ManageLotteriesOperatorDialog(dialogClient, brandClientService, lotteryClientService, notificationService, i18N) {
        this.dialogClient = dialogClient;
        this.brandClientService = brandClientService;
        this.lotteryClientService = lotteryClientService;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.isDataLoading = false;
        this.lotteries = [];
    }
    ManageLotteriesOperatorDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    ManageLotteriesOperatorDialog.prototype.save = function () {
        var _this = this;
        var lotteryIds = Enumerable.from(this.lotteries).where(function (x) { return x.isSelected; }).select(function (x) { return x.lotteryId; }).toArray();
        this.brandClientService.manageOperatorLotteriesForPricing(this.vm.item.operatorId, lotteryIds).then(function (response) {
            _this.notificationService.show(_this.i18N.tr('manage-lotteries-operator'), _this.i18N.tr('successfully-added-lotteries'), NotificationType.Success);
            _this.vm.reLoad(_this.vm.item);
            _this.dialogClient.hide();
        }, function (e) {
            _this.notificationService.show(_this.i18N.tr('manage-lotteries-operator'), _this.i18N.tr('failed-adding-lotteries'), NotificationType.Error);
        });
    };
    ManageLotteriesOperatorDialog.prototype.activate = function (model) {
        var _this = this;
        if (!model)
            return;
        this.vm = model;
        this.isDataLoading = true;
        this.lotteryClientService.getLotteries().then(function (x) {
            var e_1, _a;
            _this.lotteries = x;
            _this.isDataLoading = false;
            try {
                for (var _b = __values(_this.lotteries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var lottery = _c.value;
                    lottery.isSelected = Enumerable.from(_this.vm.dataGrid.getRowsCollection()).select(function (x) { return x.item.lotteryId; }).contains(lottery.lotteryId);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }).catch(function (x) { return _this.isDataLoading = false; });
    };
    Object.defineProperty(ManageLotteriesOperatorDialog.prototype, "allSelected", {
        get: function () {
            return Enumerable.from(this.lotteries).all(function (x) { return x.isSelected; });
        },
        set: function (selected) {
            this.lotteries.forEach(function (x) { return x.isSelected = selected; });
        },
        enumerable: false,
        configurable: true
    });
    ManageLotteriesOperatorDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService, BrandClientService,
            LotteryClientService, NotificationClientService, I18N])
    ], ManageLotteriesOperatorDialog);
    return ManageLotteriesOperatorDialog;
}());
export { ManageLotteriesOperatorDialog };
